import React, { useEffect, useState } from "react";
import { SendPostRequest } from "../../http";
import Spinner from "../Spinner";
import { capitalize } from "@mui/material";
import { useSelector } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import OwlCarousel from "react-owl-carousel";

// ✅ Convert HTML to plain text
const htmlToText = (html = "") => {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
    return (doc.body.textContent || "").replace(/\s+/g, " ").trim();
  } catch {
    return (html || "").replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
  }
};

// ✅ Make excerpt with ellipsis only if needed
const makeExcerpt = (html = "", limit = 80) => {
  const text = htmlToText(html);
  if (text.length <= limit) return { excerpt: text, isLong: false };
  return { excerpt: text.slice(0, limit).trimEnd() + "…", isLong: true };
};

function CommentBlockReviews() {
  const sitedata = useSelector((store) => store.global.loginData);
  const [reviewsData, setReviewsData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedReview, setSelectedReview] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    getReviewsData();
  }, []);

  const getReviewsData = async () => {
    try {
      setIsLoading(true);
      const response = await SendPostRequest("reviews");
      setReviewsData(response?.data || []);
    } catch (error) {
      console.error("Error fetching reviews:", error);
      setReviewsData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleShowMore = (review) => {
    setSelectedReview(review);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReview(null);
  };

  return (
    <>
      {isLoading ? (
        <div className="d-flex justify-content-center">
          <Spinner />
        </div>
      ) : reviewsData?.length > 0 ? (
        <div className="container mt-5 mb-5">
          <div className="row">
            <div className="offset-md-2 col-md-8 text-center mb-5">
              <h2 className="section-title text-uppercase">
                Patient <span className="theme-color">Reviews</span>
              </h2>
              <span className="section-border-bottom center"></span>
            </div>

            <div className="col-md-12 testimonails mb-5" data-animation="fadeInRight">
              <OwlCarousel
                className="owl-carousel testimonial-style-5 dark-switch"
                loop
                nav={false}
                dots={false}
                autoplay={true}
                autoplayHoverPause
                autoplayTimeout={3000}
                smartSpeed={250}
                margin={30}
                items={3}
                responsive={{
                  0: { items: 1 },
                  768: { items: 2 },
                  1024: { items: 3 },
                }}
              >
                {reviewsData.map((data) => {
                  const { excerpt, isLong } = makeExcerpt(data?.detail, 80);

                  return (
                    <div className="item" key={data?.id}>
                      <div
                        className="client-box text-left"
                        style={{ height: "170px", width: "85%", maxWidth: "100%" }}
                      >
                        <div className="client-image">
                          <img
                            className="img-circle img-thumbnail"
                            src={data?.profile_image || "/assets/img/no-image.png"}
                            alt={data?.name || "reviewer"}
                            style={{ width: "65px", height: "auto" }}
                          />
                        </div>

                        <p>
                          {excerpt}
                          {isLong && (
                            <Link
                              to="#"
                              onClick={(e) => {
                                e.preventDefault();
                                handleShowMore(data);
                              }}
                              className="fw-bold ms-1"
                            >
                              See More
                            </Link>
                          )}
                        </p>

                        <div className="client-details">
                          <strong className="theme-color mb-2">{data?.name}</strong>
                          <span>{data?.position}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </OwlCarousel>
            </div>
          </div>
        </div>
      ) : (
        <div className="text-center mt-5">No Reviews Available</div>
      )}

      {/* ✅ Modal with full HTML detail */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Review Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedReview && (
            <div
              dangerouslySetInnerHTML={{ __html: selectedReview?.detail || "" }}
            />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="btn btn-default" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default CommentBlockReviews;
